var symphony = symphony || {};

;
(function () {
    symphony.countdownTimers = [];
    symphony.getCountdown = function ($container, header, endDate, description, backgroundColor, borderColor, fontColor) {
        if (!symphony || !symphony.strings || !Handlebars.helpers['getSymphonyString']) {
            setTimeout(function() {
                symphony.getCountdown($container, header, endDate, description, backgroundColor, borderColor, fontColor);
            }, 1000);
            return;
        }

        var timer;
        var existingTimer = $.grep(symphony.countdownTimers, function (t) {
            return t.id == $container.attr('id');
        })[0];
        if (existingTimer != null) {
            symphony.countdownTimers = $.grep(symphony.countdownTimers, function (t) {
                return t.id !== $container.attr('id');
            });
            clearInterval(existingTimer.timer);
        }

        header = header ? header : '';
        endDate = endDate ? endDate : new Date();
        description = description ? description : '';

        function renderCountdown($container) {
            if ($container.find(".countdown-container").length > 0) {
                CountDownTimer(endDate, $container);

                function CountDownTimer(dt, $container) {
                    var end = new Date(dt);

                    var _second = 1000;
                    var _minute = _second * 60;
                    var _hour = _minute * 60;
                    var _day = _hour * 24;

                    function showRemaining($container) {
                        var now = new Date();

                        var distance = end - now;
                        var days = Math.floor(distance / _day);
                        var hours = Math.floor((distance % _day) / _hour);
                        var minutes = Math.floor((distance % _hour) / _minute);
                        var seconds = Math.floor((distance % _minute) / _second);

                        $container.find('.countdown-days-number').html(days > 1 ? days : '0')
                        $container.find('.countdown-hours-number').html(hours > 1 ? hours : '0')
                        $container.find('.countdown-minutes-number').html(minutes > 1 ? minutes : '0')
                        $container.find('.countdown-seconds-number').html(seconds > 1 ? seconds : '0')
                    }

                    timer = setInterval(function () {
                        showRemaining($container)
                    }, 1000);
                    symphony.countdownTimers.push({
                        id: $container.attr('id'),
                        timer: timer
                    });
                }
            }
        }

        setTimeout(function () {
            renderCountdown($container);
        }, 300);

        $container.html(symphony.templates['countdown']({
            header: header,
            description: description,
            backgroundColor: backgroundColor,
            borderColor: borderColor,
            fontColor: fontColor
        }))
    };

})();
